import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import * as forge from 'node-forge';
@Injectable()
export class ManufacturerService { 
  publicKey: string = `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoRuUJ/00OTIh82a1EfXu
    Qp1QfPn3bQPSjt/7h3EvYceB/bCsLgofbKQ+kvwTSz0ERNKTcSB3XUvu02VMk5YK
    bkAIchEacdYFqDDnw9nACFZJn3qyJI/SF5m7JUiaf3KS2trUh+whCHBE/TzezBx+
    I+WNrOeCUdnd0XXuTIOyay9E+E//4nUZgmJ9XY/Jjb81sq1voxV6pVy1+BEel4BQ
    sBnAxNWEx9KTlpMjuHK2aqOkCNTTv5G0yefGdWcXIGdFXOhECE9b12p3Nc4OGx5d
    /LKb7m2kSeKjj1jPnjNHVDrnrzRnEcIKmDjwAL7FequkW3OYhmP/enuvYL55GTyA
    fwIDAQAB
    -----END PUBLIC KEY-----`;
    otpEncrypt: any;
  getEventRoute = "/api/dbtmanufacturer/";

  constructor(private dataService: DataService) {}
  save(result: any) {
    return this.dataService
      .post("/api/dbtmanufacturer/", result)
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }

  getManufacturerTreeChart(id: number, refresh: boolean) {
    return this.dataService.getData(
      "/api/dbtmanufacturer/manufacturerinfotreechartDetail/" + id,
      refresh
    );
  }

  getManufacturerTreeChartflow(id: number,isAllDistrict:boolean,year:any, refresh: boolean) {
    return this.dataService.getData(
      "/api/dbtmanufacturer/manufacturerinfotreechart/" + id + '/' +isAllDistrict +'/'+year,
      refresh
    );
  }

  ProductDealerApproved(result: any) {
    return this.dataService.post("/api/dbtproduct/productdealerapprove", result).map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }
  

  ApproveProductDealer(result:any)
  {
    return this.dataService.post("/api/dbtproduct/productdealerapprovelist", result).map((response) => {
      this.dataService.clearRouteCache(this.getEventRoute);
      return response;
    });
  }

  getManufacturer(id: number, refresh: boolean) {
    return this.dataService.getData("/api/dbtmanufacturer/" + id, refresh);
  }
  getManufacturertimeline(id: number, refresh: boolean) {
    return this.dataService.getData("/api/dbtmanufacturer/" + id, refresh);
  }

  getManufacturerTimeLine(id: number, refresh: boolean) {
    return this.dataService.getData(
      "/api/dbtmanufacturer/timeline/" + id,
      refresh
    );
  }

  getManufacturerDetail(yearId:any,refresh: boolean) {
    return this.dataService.getData('/api/dbtmanufacturer/manufacturerDashboard/'+yearId, refresh);
}

getDealerDetail(refresh: boolean) {
  return this.dataService.getData('/api/dbtdealer/dashboard', refresh);
}

  getProductTreeChart(id: number, refresh: boolean) {
    return this.dataService.getData(
      "/api/dbtproduct/productinfotreechartDetail/" + id,
      refresh
    );
  }

  getProductTreeChartflow(id: number,isAllDistrict:boolean,year:any) {
    return this.dataService.getData(
      "/api/dbtproduct/productinfotreechart/" + id + '/' + isAllDistrict+'/'+year,
      true
    );
  }

  
  getManufacturerEditType(id: number, refresh: boolean) {
    return this.dataService.getData(
      "/api/dbtmanufacturer/clarification/" + id,
      refresh
    );
  }
  getproductclarificationType(id: number, refresh: boolean) {
    return this.dataService.getData(
      "/api/dbtproduct/clarification/" + id,
      refresh
    );}
  getManufacturerList(refresh: boolean) {
    return this.dataService.getData(
      "/api/dbtmanufacturer/manufacturerof",
      refresh
    );
  }
  

  getmanufacturerList(refresh: boolean) {
    return this.dataService.getData("/api/dbtmanufacturer", refresh);
  }

  getdashboardDataList(yearId:any,refresh: boolean) {
    return this.dataService.getData("/api/dbtmanufacturer/dashboard/"+yearId, refresh);
  }

  getCompanyRegisterList(refresh: boolean) {
    return this.dataService.getData("/api/lookup/companyregistertype", refresh);
  }

  manufacturerApprove(result: any) {
    return this.dataService
      .post("/api/dbtmanufacturer/approvedmanufacturer", result)
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }
  delerunmap(result: any) {
    return this.dataService
      .post("/api/dbtproduct/productmappingremove", result)
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }

  manufacturerBlock(result: any) {
    return this.dataService
      .post("/api/dbtmanufacturer/manufacturerrejandblock", result)
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }
  manufacturerUnBlock(result: any) {
    return this.dataService
      .post("/api/dbtmanufacturer/unblockmanufacturer", result)
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }

  manufacturerLock(result: any) {
    return this.dataService
      .post("/api/dbtmanufacturer/lockmanufacturer", result)
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }

  update(result: any) {
    return this.dataService
      .post("/api/dbtmanufacturer/Update", result)
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }

  geteditmanufacturedropdown(refresh: boolean) {
    return this.dataService.getData(
      "/api/lookup/manufactureredittype",
      refresh
    );
  }
  getmachineryUnreachableReasonType(refresh: boolean) {
    return this.dataService.getData(
      "/api/lookup/machineryUnreachableReasonType",
      refresh
    );
  }
  getmachineryUnreachableReasonTypenew(refresh: boolean) {
    return this.dataService.getData(
      "/api/lookup/machineryUnreachableReasonType",
      refresh
    );
  }
  
  savemachineryUnreachableReasonType(result: any) {
    return this.dataService.post('/api/vehicle/machineryActivityLogSave', result).map(response => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
    });
}
  sendOtp(result :any){
  return this.dataService.post('/api/dbtmanufacturer/generateotp', result).map(response => {
    return response;
  });
  }
  OtpVerification(result: any, refresh: boolean) {          
          if(result){
          var rsa = forge.pki.publicKeyFromPem(this.publicKey);
          // var encryptedPassword = window.btoa(rsa?.encrypt(result?.enteredOtp));
          const data = {
              id: result.id,
              otp: result.enteredOtp
          }
          return this.dataService.post('/api/dbtmanufacturer/verifyotp', data)
        }
       
      }
  clarificationsave(result: any) {
    return this.dataService
      .post("/api/dbtmanufacturer/clarificationsave", result)
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }
  gpsMalfunctionActivityLogSave(result){
    return this.dataService
    .post("/api/vehicle/gpsMalfunctionActivityLogSave", result)
    .map((response) => {
      this.dataService.clearRouteCache(this.getEventRoute);
      return response;
    });
  }
  getgpsMalfunctionActivityLog(vehicleId,refresh){
    return this.dataService.getData(
      "/api/vehicle/gpsMalfunctionActivityLog/" + vehicleId,
      refresh
    );
  }
  getgpsmalfunctionreason(refresh){
    return this.dataService.getData(
      "/api/lookup/gpsmalfunctionreason",refresh
    );
    
  }
}
